import { render, staticRenderFns } from "./blockChainBrowser.vue?vue&type=template&id=4e1e8e16&scoped=true&"
import script from "./blockChainBrowser.vue?vue&type=script&lang=ts&"
export * from "./blockChainBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./blockChainBrowser.vue?vue&type=style&index=0&id=4e1e8e16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e8e16",
  null
  
)

export default component.exports